import { getApiBaseUrl } from '../utils/apiBaseUrl'
import { GetAddressesResponse } from './GetAllAddressesAsync';

export interface AllUsersData {
  id: number;
  userName: string | null;
  email: string | null;
  phoneNumber: string | null;
  createdDate: string | null; 
  roleId: number | null;
  roleName: string | null;
}

export interface GetUsersResponse {
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  data: AllUsersData[];
}

export const GetAllUsersAsync = async (
  pageNumber: number,
  pageSize: number,
  search: string,
  token: string
): Promise<GetUsersResponse> => {
  const baseUrl = getApiBaseUrl();
  const apiUrl = `${baseUrl}/api/Admin/GetAllUsersAsync?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${search}`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch user information`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error in GetAllUsersAsync:', error);
    throw error;
  }
};
